export default __webpack_public_path__ + "static/char-06-anr-70a420e822391216874bee2f9980f641.webp";